/**
 * @generated SignedSource<<d92b8c98ca7ec09b289c3c38e834c94b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useGetNextPaymentDate_memberPackage$data = {
  readonly orders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly isPaid: boolean | null | undefined;
        readonly packageDueDate: string | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useGetNextPaymentDate_memberPackage";
};
export type useGetNextPaymentDate_memberPackage$key = {
  readonly " $data"?: useGetNextPaymentDate_memberPackage$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetNextPaymentDate_memberPackage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetNextPaymentDate_memberPackage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OrderConnection",
      "kind": "LinkedField",
      "name": "orders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Order",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isPaid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "packageDueDate",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MemberPackage",
  "abstractKey": null
};

(node as any).hash = "6ec31a8e4081616f07ad632f200bf857";

export default node;
